export default __webpack_public_path__ + "static/media/WM0480.34I-43866_-26182_0.336070be.jpg";